import { render, staticRenderFns } from "./TableManagerHeader.vue?vue&type=template&id=b593e6d2&"
import script from "./TableManagerHeader.vue?vue&type=script&lang=ts&"
export * from "./TableManagerHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports